$(".load-more-lessons").click(function () {
  Array.from(document.querySelectorAll("#accordion")).forEach((el) =>
    el.classList.add("d-block")
  )
  $(this).addClass("d-none")
})
